import { InjectionToken } from '@angular/core';
import { ICartConfig } from '../models/cart-config.model';

export const CartConfigToken = new InjectionToken<ICartConfig>('ShoppingCartConfig');
